import { render, staticRenderFns } from "./AssistantList.vue?vue&type=template&id=2bbbe7ce"
import script from "./AssistantList.vue?vue&type=script&lang=js"
export * from "./AssistantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports